import { useUserProfile } from '../../../context/UserProfileContext/UserProfileContext';
import { useReportingInfoBanner } from '../../../services/reportingInfoBanner';
import { usePartnershipsInfoBanner } from '../../../services/partnershipsInfoBanner';
import dompurify from 'dompurify';

export const useAnnouncements = () => {
  const { userProfile } = useUserProfile();

  const { data: reportingInfoBanners = [] } = useReportingInfoBanner({
    enabled: !!userProfile?.allowedModules.canAccessReporting
  });

  const { data: partnershipsInfoBanners = [] } = usePartnershipsInfoBanner({
    enabled: !!userProfile?.allowedModules.canAccessPartnerships
  });

  const banners = [...reportingInfoBanners, ...partnershipsInfoBanners].map(
    ({ content, ...otherProps }) => ({
      ...(content && {
        content: dompurify.sanitize(content)
      }),
      ...otherProps
    })
  );

  return {
    banners
  };
};
